import UseCase, { NoParams } from "../../core/useCase/UseCase";
import { UserRepository } from "../repository/UserRepository";

/**
 * Refreshes the stored credential with one authenticated call to the auth
 * service, which rotates the token when it is inside its renewal window.
 *
 * Separate from GetUser on purpose. GetUser feeds React auth state and chains
 * into getApplication(), so calling it on every renewal would flash the
 * dashboard's loading skeletons and re-fire the userSetted /
 * applicationSetted GTM events at a member who is actively working. This
 * produces no User and touches no state.
 */
export default class RenewSession extends UseCase<void, NoParams> {
  repository: UserRepository;

  constructor(repository: UserRepository) {
    super();
    this.repository = repository;
  }

  execute = () => this.repository.renewSession();
}
